import { Button as MuiButton } from "@mui/material";
import { Link } from "react-router-dom";

const Button = ({ label, type, bgColor, style, url }) => {
  return url ? (
    <Link to={url} style={{ textDecoration: "none" }}>
      <MuiButton
        variant="contained"
        sx={{
          background: bgColor,
          paddingLeft: "32px",
          paddingRight: "32px",
          ...style,
          "&:hover": {
            backgroundColor: "#813333",
          },
        }}
        type={type}
      >
        {label}
      </MuiButton>
    </Link>
  ) : (
    <MuiButton
      variant="contained"
      sx={{
        background: bgColor,
        paddingLeft: "32px",
        paddingRight: "32px",
        ...style,
        "&:hover": {
          backgroundColor: "#813333",
        },
      }}
      type={type}
    >
      {label}
    </MuiButton>
  );
};

export default Button;
